module.exports = ":host{display:block;height:100%}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 758
// module chunks = 0